/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="../services.ts"/>
/// <reference path="./employee_interfaces.ts"/>

namespace DealerwareWebServices {
    "use strict";

    import IDealerwareEmployee = DealerwareWebServices.IDealerwareEmployee

    export class Employee implements IDealerwareEmployee {
        public static $inject: string[] = ['$injector'];

        private $q: any;
        private $timeout: any;
        private _locationId: number;
        private _employeeId: number;
        private DealerwareEmployeeModel: any;
        private CurrentUser: any;

        public accountSettings: any;

        constructor(public $injector : any) {
            this.$q = this.$injector.get('$q');
            this.$timeout = this.$injector.get('$timeout');
            this.DealerwareEmployeeModel = this.$injector.get('DealerwareEmployeeModel');
            this.CurrentUser = this.$injector.get('CurrentUser');
        }

        get locationId() : number {
            return this._locationId;
        }

        set locationId(id: number) {
            this._locationId = id;
        }

        get employeeId() : number {
            return this._employeeId;
        }

        set employeeId(id : number)  {
            if (id && this._employeeId && id != this._employeeId) {
                throw "Employee ID Mismatch";
            }
            this._employeeId = id;
        }

        get fullName() : string {
            return (
                        this.accountSettings &&
                        this.accountSettings.hasOwnProperty('data') &&
                        angular.isObject(this.accountSettings.data) &&
                        this.accountSettings.data.hasOwnProperty('user_profile_attributes') &&
                        angular.isObject(this.accountSettings.data.user_profile_attributes) &&
                        this.accountSettings.data.user_profile_attributes.hasOwnProperty('full_name')) ?
                        this.accountSettings.data.user_profile_attributes.full_name : undefined;
        }

        set fullName(fullName : string) {}

        get email() : string {
            return  (
                this.accountSettings &&
                this.accountSettings.hasOwnProperty('data') &&
                angular.isObject(this.accountSettings.data) &&
                this.accountSettings.data.hasOwnProperty('email')
            ) ? this.accountSettings.data.email : undefined;
        }

        public clear() : void {
            this._employeeId    =   null;
            this.clearAccountSettings();
        }

        public clearAccountSettings() : void {
            this.accountSettings = undefined;
        }

        public loadAccountSettings(locationId?: number, employeeId? : number) : ng.IPromise<{}> {
            var _deferred   =   this.$q.defer();
            var _self       =   this;

            if (locationId) { this.locationId = locationId; }
            if (employeeId) { this.employeeId = employeeId; }

            if (!this.locationId) {
                _deferred.reject({response : {data: {'message': 'Location Id is undefined'}}});
            } else if (!this.employeeId) {
                _deferred.reject({response : {data: {'message': 'Employee Id is undefined'}}});
            } else {
                this.DealerwareEmployeeModel.get({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                        id: this.employeeId,
                        include_user_profile: true
                    }
                }).then(
                    function(returnValue : any, response : any) {
                        _self.accountSettings = returnValue;

                        if (_self.CurrentUser.user.hasRole('user_role_manager') && _self.accountSettings.data.active) {
                            _self.loadRoles().then(
                                function() {
                                    _deferred.resolve({returnValue: _self.accountSettings, response: response });
                                },
                                function(response: any) {
                                    _deferred.reject(response);
                                }
                            );
                        } else {
                            _deferred.resolve({returnValue: _self.accountSettings, response: response });
                        }
                    },
                    function(response : any) {
                        _deferred.reject(response);
                    }
                );
            }

            return _deferred.promise;
        }

        public loadAccountSettingsByConfirmationToken(confirmationToken: string) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (!confirmationToken) {
                _deferred.reject({ response : { data: { message: 'Confirmation token is undefined' }}});
            } else {
                this.DealerwareEmployeeModel.getByConfirmationToken({
                    promise: true,
                    params: { confirmation_token: confirmationToken }
                }).then(
                    function(returnValue : any, response : any) {
                        _self.accountSettings = returnValue;
                        _deferred.resolve({returnValue: returnValue,response : response});
                    },
                    function(response : any) {
                        _deferred.reject(response);
                    }
                );
            }

            return _deferred.promise;
        }

        public loadRoles() : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (!this.locationId) {
                _deferred.reject({response : {data: {'message': 'Location Id is undefined'}}});
            } else if (!this.employeeId) {
                _deferred.reject({response : {data: {'message': 'Employee Id is undefined'}}});
            } else {
                this.DealerwareEmployeeModel.getRoles({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                        id: this.employeeId
                    }
                }).then(
                    function(returnValue: any, response: any) {
                        _self.accountSettings.data.roles_mapped = returnValue.data;
                        _deferred.resolve({returnValue: returnValue, response: response});
                    },
                    function(response: any) {
                        _deferred.reject(response);
                    }
                );
            }

            return _deferred.promise;
        }

        public searchDisplay() : string {
            return this.accountSettings.searchDisplay();
        }
    }

    getDealerwareWebServicesModule().service("$dealerwareEmployee", Employee);


    export class EmployeeFactory implements IDealerwareEmployeeFactory {
        public static $inject: string[] = ['$q','$injector'];

        constructor(public $q : any,public $injector : any) {}

        public loadEmployee(locationId: number, id: number) : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _employee = new Employee(this.$injector);

            _employee.loadAccountSettings(locationId, id).then(
                function(response: ng.IHttpPromiseCallbackArg<{}>) {
                    _deferred.resolve({employee: _employee});
                },
                function(response: any) {
                    _deferred.reject(response);
                }
            );
            return _deferred.promise;
        }

        public loadEmployeeByConfirmationToken(confirmationToken: string) : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _employee = new Employee(this.$injector);

            _employee.loadAccountSettingsByConfirmationToken(confirmationToken).then(
                function(response: ng.IHttpPromiseCallbackArg<{}>) {
                    _deferred.resolve({employee: _employee});
                },
                function(response: any) {
                    _deferred.reject(response);
                }
            );

            return _deferred.promise;
        }

        public getInstance(): IDealerwareEmployee {
            return new Employee(this.$injector);
        }

        public convertToInstance(employeeData: any) : IDealerwareEmployee {
            var _new: any;

            if (employeeData && (employeeData instanceof Employee)) {
                _new = employeeData;
            } else if (employeeData) {
                _new = new Employee(this.$injector);
                _new.accountSettings = employeeData;
            } else {
                _new = employeeData;
            }

            return _new;
        }
    }

    getDealerwareWebServicesModule().service("$dealerwareEmployeeFactory", EmployeeFactory);
}
